import React from 'react'
import styled from 'styled-components'

import { SIZES, COLORS } from '~/common/globalStyles'
import Text from '~/views/components/ui/Text'
import { numberHelpers } from '~/utils/numbers'

type ProgressBarLabels = {
  task: string
  tasks: string
}

interface ProgressBarLabelProps {
  color: keyof typeof COLORS
  label: string
  total: number
  percentage: number
  labels: ProgressBarLabels
}

const ProgressBarLabelWrapper = styled.div`
  display: flex;
  align-items: center;
`

const ProgressBarLabelCircle = styled.div<{
  color: ProgressBarLabelProps['color']
}>`
  width: ${SIZES.medium};
  height: ${SIZES.medium};
  border-radius: 50%;
  background-color: ${(props) => COLORS[props.color]};
`

export const ProgressBarLabel = ({
  label,
  percentage,
  total,
  color,
  labels,
  ...rest
}: ProgressBarLabelProps) => {
  return (
    <ProgressBarLabelWrapper>
      <ProgressBarLabelCircle color={color} />
      <div>
        {/* Need to pass the test id here */}
        <ProgressBarLabelInner {...rest}>
          <ProgressBarLabelInnerDiv>
            <Text size="medium" color="mediumGray">
              {label}
            </Text>
          </ProgressBarLabelInnerDiv>
          <ProgressBarLabelInnerDiv>
            <Text size="medium" color="darkGray" weight="bold">
              {numberHelpers.prettyPercent(percentage)}
            </Text>
          </ProgressBarLabelInnerDiv>
          <ProgressBarLabelInnerDiv>
            <Text size="medium" color="darkGray">
              ({total} {total !== 1 ? labels.tasks : labels.task})
            </Text>
          </ProgressBarLabelInnerDiv>
        </ProgressBarLabelInner>
      </div>
    </ProgressBarLabelWrapper>
  )
}

export const ProgressBarLabelInner = styled.div`
  display: flex;
  justify-content: space-between;
`

export const ProgressBarLabelInnerDiv = styled.div`
  margin-left: ${SIZES.small};
`

export const ProgressBarLabelGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`
